<template>
  <div>
    <a
      @click="show = !show"
      class="link-dotted mr-2"
    >
      {{ $t('preview') }}
    </a>
    <VDialog v-model="show" width="800">
      <VCard class="preview-question">
        <VIcon class="preview-question__close" color="white" @click="show = false">
          mdi-close-circle-outline
        </VIcon>
        <VBtn
          class="preview-question__btn"
          fab
          @click="toggle"
        >
          <VIcon>
            {{ isPlaying ? 'mdi-pause' : 'mdi-play' }}
          </VIcon>
        </VBtn>
        <video
          class="preview-question__video"
          ref="video"
          :src="url"
          @ended="toggle"
        />
        <div class="preview-question__text">
          {{ question.question }}
        </div>
      </VCard>
    </VDialog>
  </div>
</template>

<script>
import InterviewerTracks from '@huntica/huntica-interview-module/src/helpers/InterviewerTracks';
import { videoResolution } from '@huntica/huntica-interview-module/src/enums';
import Interviewer from '@/orm/models/Interview/Interviewer';
import Vacancy from '@/orm/models/Vacancy/Vacancy';

export default {
  name: 'VacancyQuestionTextPreview',
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      isPlaying: false,
      url: '',
      interviewer: null,
    };
  },
  watch: {
    show() {
      if (this.show) {
        this.$nextTick(() => {
          this.preloadVideo();
        });
      }
    },
  },
  created() {
    this.loadMedia();
  },
  methods: {
    toggle() {
      if (this.isPlaying) {
        this.$refs.video.pause();
      } else {
        this.$refs.video.play();
      }
      this.isPlaying = !this.isPlaying;
    },
    async fetchInterviewer() {
      let { interviewerId } = this.$route.params;
      if (!interviewerId) {
        interviewerId = this.getInterviewerId();
      }
      await Interviewer.api().fetchAll();
      this.interviewer = Interviewer.find(interviewerId);
    },

    getInterviewerId() {
      const { id } = this.$route.params;
      const vacancy = Vacancy.find(id);
      return vacancy.script.interviewerId;
    },

    preloadVideo() {
      const video = this.$refs.video[0];
      if (!video) {
        return;
      }
      video.addEventListener('loadeddata', () => {
        video.currentTime = 0;
      });
      video.load();
    },

    async loadMedia() {
      await this.fetchInterviewer();
      const tracks = new InterviewerTracks(this.interviewer.videoUrl);
      await tracks.load();
      let files = tracks.getFilesTrack(videoResolution.HD, 1.777777778);
      if (!files) {
        files = tracks.getFilesTrack(videoResolution.FULL_HD, 1.777777778);
      }
      this.url = tracks.buildUrl(`${files.path}/text_question_1.mp4`);
    },

  },
};
</script>

<style lang="scss" scoped>
.preview-question {
  position: relative;

  &__btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -60%);
    display: block;
    width: 100px !important;
    height: 100px !important;
    background: rgba(255, 255, 255, 0.4) !important;
    z-index: 100;

    i {
      font-size: 70px !important;
    }
  }

  &__video {
    display: block;
    max-width: 100%;
    min-height: 450px;
  }

  &__text {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    display: block;
    padding: 25px 120px;
    width: 100%;
    text-align: center;
    background: rgba(0, 0, 0, 0.8);
    color: white;
    font-weight: 500;
    font-size: 22px;
    line-height: 28px;
  }

  &__close {
    position: absolute;
    font-size: 30px;
    top: 10px;
    right: 10px;
    cursor: pointer;
    z-index: 100;
  }
}
</style>

<i18n locale="en" lang="yaml">
preview: Preview
</i18n>

<i18n locale="ru" lang="yaml">
preview: Предпросмотр
</i18n>
